import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OeAppPersonService } from './oe-app-person.service';
import { OeAppService } from './oe-app.service';

interface ShouldForceLogOutResponse {
  token: string;
  forceLogOut: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SensitiveSessionService {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  shouldForceLogOut(): Observable<boolean> {
    const personId = this.oeAppPersonService.id;
    return this.http
      .get<ShouldForceLogOutResponse>(
        `${this.oeAppService.oeProfileServiceHost}/v1/sensitive-sessions/should-force-log-out`,
        { params: new HttpParams().set('personId', String(personId)) }
      )
      .pipe(
        map((res) => !!(res && res.forceLogOut)),
        catchError(() => of(false))
      );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/sensitive-session.service.ts